import React from 'react';
import {
  ArrayInput,
  SimpleFormIterator,
  TextInput,
  NumberInput,
  DateInput,
  required,
  useTranslate,
} from 'react-admin';
import { useWatch } from 'react-hook-form';
import moment from 'moment';
import { shouldFieldBeDisabled, getFieldHelperText } from '../../../utils/eventFormUtils';
import { ScopedIteratorFields } from '../event-utils/ScopedIteratorFields';

/**
 * Event Coupons Tab Component
 * Handles coupon management
 */
export const EventCouponsTab = ({ isEdit = false }) => {
  const translate = useTranslate();
  const startdate = useWatch({ name: 'startdate' });

  return (
    <React.Fragment>
      <h3>{translate('form.coupons', 'Coupons')}</h3>
      <ArrayInput source="coupons" defaultValue={[]} label={translate('form.coupons', 'Coupons')}>
        <SimpleFormIterator disableReordering disableRemove={isEdit} className="couponsIterator">
          <ScopedIteratorFields>
            {({ scopedFormData, getSource }) => (
              <React.Fragment>
                <TextInput
                  source={getSource('code')}
                  label={translate('form.coupon_code', 'Coupon Code')}
                  validate={required()}
                  fullWidth
                  disabled={shouldFieldBeDisabled('code', {}, {}, scopedFormData)}
                  helperText={getFieldHelperText('code', scopedFormData)}
                />

                <NumberInput
                  onWheel={(event) => {
                    event.target.blur();
                  }}
                  source={getSource('discount')}
                  type="number"
                  label={translate('form.discount_tl', 'Discount (TL)')}
                  min={0}
                  validate={required()}
                  fullWidth
                  disabled={shouldFieldBeDisabled('discount', {}, {}, scopedFormData)}
                  helperText={getFieldHelperText('discount', scopedFormData)}
                />

                <NumberInput
                  onWheel={(event) => {
                    event.target.blur();
                  }}
                  source={getSource('stock')}
                  type="number"
                  label={translate('form.stock', 'Stock')}
                  validate={required()}
                  fullWidth
                />

                <DateInput
                  source={getSource('activeUntil')}
                  label={translate('form.active_until', 'Active Until')}
                  validate={[
                    required(),
                    (value) =>
                      moment(value).isBefore(moment(), 'day')
                        ? translate('form.active_until_after_today', 'Active until date should be after today.')
                        : undefined,
                    (value) => {
                      if (!startdate || !value) return undefined;
                      return moment(value).isAfter(moment(startdate), 'day')
                        ? translate('form.active_until_before_start', 'Active until date should be before the event start date.')
                        : undefined;
                    },
                  ]}
                  fullWidth
                />
              </React.Fragment>
            )}
          </ScopedIteratorFields>
        </SimpleFormIterator>
      </ArrayInput>
    </React.Fragment>
  );
};
